import { render, staticRenderFns } from "./EducationEventNoteForm.vue?vue&type=template&id=642d3244&scoped=true&"
import script from "./EducationEventNoteForm.vue?vue&type=script&lang=ts&"
export * from "./EducationEventNoteForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642d3244",
  null
  
)

export default component.exports